import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, apiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { KeyRound, Loader2 } from "lucide-react";
import { toast } from "sonner";

export default function SetPassword() {
  const navigate = useNavigate();
  const { user, refreshUser } = useAuth();
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async () => {
    if (pw.length < 6) { toast.error("Şifre en az 6 karakter olmalı"); return; }
    if (pw !== pw2) { toast.error("Şifreler eşleşmiyor"); return; }
    setBusy(true);
    try {
      await api.post("/auth/set-password", { new_password: pw });
      await refreshUser();
      toast.success("Şifreniz belirlendi");
      navigate("/", { replace: true });
    } catch (e) { toast.error(apiError(e)); }
    finally { setBusy(false); }
  };

  return (
    <div className="min-h-[70vh] flex items-center justify-center px-4 py-12">
      <div className="w-full max-w-md bg-white rounded-2xl border border-slate-200/80 p-8" data-testid="set-password-card">
        <div className="h-12 w-12 rounded-2xl brand-gradient text-white flex items-center justify-center mb-4"><KeyRound className="h-6 w-6" /></div>
        <h1 className="text-2xl font-extrabold text-slate-900">Şifre Belirleyin</h1>
        <p className="text-sm text-slate-500 mt-1 mb-6">Google ile giriş yaptınız. Hesabınıza e-posta ile de girebilmek için bir şifre oluşturun.{user?.email ? ` (${user.email})` : ""}</p>
        <div className="space-y-4">
          <div><Label>Yeni Şifre</Label><Input type="password" value={pw} onChange={(e) => setPw(e.target.value)} className="rounded-xl mt-1" data-testid="set-password-input" /></div>
          <div><Label>Yeni Şifre (Tekrar)</Label><Input type="password" value={pw2} onChange={(e) => setPw2(e.target.value)} className="rounded-xl mt-1" data-testid="set-password-confirm" /></div>
          <Button onClick={submit} disabled={busy} className="w-full brand-gradient text-white rounded-xl h-11 font-semibold" data-testid="set-password-submit">
            {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : "Şifreyi Kaydet"}
          </Button>
          <button onClick={() => navigate("/")} className="w-full text-sm text-slate-400 hover:text-slate-600" data-testid="set-password-skip">Şimdilik atla</button>
        </div>
      </div>
    </div>
  );
}
